<template>
  <div class="form-element">
    <label class="form-element__title" v-if="title">{{ title }}</label>
    <div
      class="form-element__upload"
      :class="{ '-drag': isDrag }"
      @dragenter="dragenter"
      @dragleave="dragleave"
    >
      <div class="form-element__upload__select">Seçiniz</div>
      <div class="form-element__upload__text">Max 3mb olmalı</div>
      <input
        id="files"
        class="form-element__upload__input"
        type="file"
        accept=".pdf"
        name="file"
        @change="filesChange($event.target.files)"
        ref="uploadFileInput"
      />
      <div class="form-element__upload__uploaded" v-if="file">{{ file }}</div>
    </div>
    <div class="form-element__message" v-if="message">
      {{ message }}
    </div>
  </div>
</template>

<script>

export default {
 
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    title: {
      type: String,
      default: null
    },
    message: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      isDrag: false,
      file: null
    }
  },
  methods: {
   
    filesChange: async function (filelist) {
      let vm = this
      
      if (!filelist.length) return

      vm.file = filelist[0].name
      let file = filelist[0]

      let _base64 = await vm.toBase64(file)
      var sl = _base64.split(',')
      
      
        
      let obj = {
        fileName: filelist[0].name,
        file: sl[1]
      }
  
      vm.$emit('input', obj)

      return
    },
    toBase64: async function (file) {
      let toBase64 = () =>
        new Promise((resolve, reject) => {
          let reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = () => resolve(reader.result)
          reader.onerror = (error) => reject(error)
        })

      return await toBase64()
    },
    
    dragenter: function () {
      this.isDrag = true
    },
    dragleave: function () {
      this.isDrag = false
    }
  }
}
</script>